import type NavBarData from 'owa-service/lib/contract/NavBarData';

interface TenantLogoData {
    /* The URL of the tenant logo */
    logoUrl?: string;
    /* The URL to navigate to when the logo is clicked */
    navigationUrl?: string;
}

/**
 * Gets the tenant logo URL from the BPOS navigation bar data.
 * @param navBarData The BPOS navigation bar data
 * @returns The tenant logo data or undefined if not available
 */
export default function getTenantLogoData(
    navBarData: NavBarData | null
): TenantLogoData | undefined {
    if (!navBarData || !navBarData.TenantLogoUrl) {
        return undefined;
    }

    return {
        logoUrl: navBarData.TenantLogoUrl.Url,
        navigationUrl: navBarData.TenantLogoNavigationUrl?.Url,
    };
}
